/** Pixel dimensions and duration (seconds) of a video. */
export interface VideoMetadata {
	width: number
	height: number
	duration: number
}

/** Loads a File as a video and resolves its dimensions and duration, used to attach metadata to uploads. */
export const extractVideoMetadata = (file: File): Promise<VideoMetadata> => {
	return new Promise((resolve, reject) => {
		const video = document.createElement("video")
		video.preload = "metadata"

		video.onloadedmetadata = () => {
			window.URL.revokeObjectURL(video.src)
			const width = video.videoWidth
			const height = video.videoHeight
			const duration = video.duration

			if (!width || !height) {
				reject(new Error("Failed to extract video dimensions"))
				return
			}

			resolve({
				width,
				height,
				duration: Math.floor(duration),
			})
		}

		video.onerror = () => {
			window.URL.revokeObjectURL(video.src)
			reject(new Error("Failed to load video metadata"))
		}

		video.src = window.URL.createObjectURL(file)
	})
}
